import { render } from "./RichSuggestion.vue?vue&type=template&id=382e4cdf&scoped=true"
import script from "./RichSuggestion.vue?vue&type=script&lang=js"
export * from "./RichSuggestion.vue?vue&type=script&lang=js"

import "./RichSuggestion.vue?vue&type=style&index=0&id=382e4cdf&lang=sass&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382e4cdf"]])

export default __exports__